import { render } from "./VocabularyTest.vue?vue&type=template&id=4f291773&scoped=true"
import script from "./VocabularyTest.vue?vue&type=script&lang=js"
export * from "./VocabularyTest.vue?vue&type=script&lang=js"

import "./VocabularyTest.vue?vue&type=style&index=0&id=4f291773&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f291773"]])

export default __exports__